import { connect } from 'react-redux';
import {
  fetchInventoryPackages,
  deleteInventoryPackage
} from '../../../redux/Inventory/sagas/package/routines';
import {
  inventoryPackagesOnChangePage,
  inventoryPackagesOnChangeOrder,
  clearInventoryPackages
} from '../../../redux/Inventory/actions';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPagePackages
} from '../../../redux/Inventory/selectors/package/pagination';
import {
  getIsFetching as getIsFetchingPackages,
  getIsFetched as getIsFetchedPackages,
  getIsDeleting as getIsDeletingPackage,
  getIsDeleted as getIsDeletedPackage,
  getDeletingError as getDeletePackcageError,
  getOrder as getPackagesOrder
} from '../../../redux/Inventory/selectors/package';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import { PackageType } from '../../../constants/inventory/InventoryTypes';
import InventoryItemList from '../../../components/inventory/ItemList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.PACKAGE);
  const order = getPackagesOrder(state);

  return {
    type: PackageType,
    items: orderList(order, getCurrentPagePackages(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetchingPackages(state),
    isFetched: getIsFetchedPackages(state),
    isDeleting: getIsDeletingPackage(state),
    isDeleted: getIsDeletedPackage(state),
    deleteError: getDeletePackcageError(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchInventoryPackages(query));
    },
    onDelete: item => {
      dispatch(deleteInventoryPackage(item));
    },
    onChangePage: (query, isPageLoaded) => {
      if (!isPageLoaded) dispatch(fetchInventoryPackages(query));
      else dispatch(inventoryPackagesOnChangePage(query.page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryPackages());
      dispatch(fetchInventoryPackages(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearInventoryPackages());
      dispatch(fetchInventoryPackages({ ...query, order }));
      dispatch(inventoryPackagesOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryItemList);
